import * as styled from './styles';
import { PhoneStep } from './ui/phone-step';
import { OtpStep } from './ui/otp-step';
import { ConfirmStep } from './ui/confirm-step';
import { TestimonialsSection } from './ui/testimonials-section';

type Props = {
  step: Account.Step;
  countryCode: string;
  localNumber: string;
  otpCode: string;
  months: number;
  isLoading: boolean;
  error: string | null;
  provider: Account.FoundProvider | null;
  onCountryCodeChange: (v: string) => void;
  onLocalNumberChange: (v: string) => void;
  onOtpCodeChange: (v: string) => void;
  onMonthsChange: (v: number) => void;
  onRequestOtp: () => void;
  onVerifyOtp: () => void;
  onBackToPhone: () => void;
  onPay: () => void;
};

export const SubscribeScene = ({
  step,
  countryCode,
  localNumber,
  otpCode,
  months,
  isLoading,
  error,
  provider,
  onCountryCodeChange,
  onLocalNumberChange,
  onOtpCodeChange,
  onMonthsChange,
  onRequestOtp,
  onVerifyOtp,
  onBackToPhone,
  onPay,
}: Props) => (
  <div>
    <styled.TopBar>
      <styled.Logo>Kudable</styled.Logo>
    </styled.TopBar>

    <styled.Container>
      {step === 'phone' && (
        <PhoneStep
          countryCode={countryCode}
          localNumber={localNumber}
          isLoading={isLoading}
          error={error}
          onCountryCodeChange={onCountryCodeChange}
          onLocalNumberChange={onLocalNumberChange}
          onRequestOtp={onRequestOtp}
        />
      )}

      {step === 'otp' && (
        <OtpStep
          countryCode={countryCode}
          localNumber={localNumber}
          otpCode={otpCode}
          isLoading={isLoading}
          error={error}
          onOtpCodeChange={onOtpCodeChange}
          onVerifyOtp={onVerifyOtp}
          onBackToPhone={onBackToPhone}
        />
      )}

      {step === 'confirm' && provider && (
        <ConfirmStep
          months={months}
          isLoading={isLoading}
          error={error}
          provider={provider}
          onMonthsChange={onMonthsChange}
          onPay={onPay}
        />
      )}

      <TestimonialsSection />
    </styled.Container>
  </div>
);
